'use strict';

const enumFromObject = require('./enumfromobject');

const FeatureTypes = {
  SECURITAS_SUPERVISION: 'securitassupervision',
  CELL_BACKUP: 'cellbackup',
  TWILIO_KEYHOLDER_RESPONSE: 'twiliokeyholderresponse',
  ONLINE_STORAGE_CAMERA: 'cameraonlinestorage',
  ADVANCED_AI_CAMERA: 'cameraadvancedai',
};

module.exports = {
  FeatureEnablementFeatureTypes: enumFromObject(FeatureTypes),
};
